module.exports = __webpack_public_path__ + "static/media/title.4a972825.png";